<template>
  <div>

    <b-input-group>
      <b-input-group-prepend>
        <b-input-group-text>@</b-input-group-text>
      </b-input-group-prepend>
      <b-form-input
        v-model="email"
        type="text"
        class="form-control"
        placeholder="Email"
        autocomplete="email"
        :state="vuelidate.$dirty ? !vuelidate.$invalid : null"
      />
      <b-form-invalid-feedback>
        Required
      </b-form-invalid-feedback>
    </b-input-group>

  </div>
</template>

<script>
export default {
  name: 'CustomerContactEmailForm',
  props: {
    customer_contact_email: {
      type: String,
      default: null
    },
    vuelidate: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      email: null
    }
  },
  watch: {
    email: {
      handler: function () {
        this.$emit('onChange', this.email)
      }
    },
    customer_contact_email: {
      handler: function () {
        this.fillForm()
      },
      deep: true
    }
  },
  created () {
    this.fillForm()
  },
  methods: {
    fillForm () {
      this.email = this.customer_contact_email
    }
  }
}
</script>
